var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vx-card',{staticClass:"mb-8 vs-con-loading__container",attrs:{"id":"consultationDataContainer","title":_vm.$tc('schedules')}},[_c('calendar-month',{attrs:{"dates":_vm.dates},on:{"select":_vm.getSchedule,"dateChange":_vm.fetchSchedules}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }